export type IntervalUnit = 'day' | 'week' | 'month' | 'year';

export const INTERVAL_UNITS: { value: IntervalUnit, label: string }[] = [
  { value: 'day', label: 'Days' },
  { value: 'week', label: 'Weeks' },
  { value: 'month', label: 'Months' },
  { value: 'year', label: 'Years' },
];

export class InspectionType {
  id: number = -1;
  name: string = '';
  intervalNumber: number = 1;
  intervalUnit: IntervalUnit = 'month';
  colour: string = '#0275d8';
  /** How long a booking starts out on the workshop scheduler. */
  defaultDurationMinutes: number = 60;
  active: boolean = true;
}

export interface VehicleInspection {
  id: number;
  vehicleId: number;
  inspectionTypeId: number;
  nextDueDate: string;
  lastDoneDate: string | null;
  notes: string | null;
  vehicle?: { id: number, registration: string, name: string, active: boolean };
  inspectionType?: InspectionType;
}

/** One due inspection on the calendar (GET vehicle-inspection/calendar). */
export interface CalendarItem {
  id: number;
  vehicleId: number;
  registration: string;
  vehicleActive: boolean;
  inspectionTypeId: number;
  typeName: string;
  colour: string;
  nextDueDate: string;
  lastDoneDate: string | null;
  overdue: boolean;
}

export interface InspectionRecord {
  id: number;
  vehicleInspectionId: number;
  dueDate: string;
  doneDate: string;
  nextDueDate: string;
  notes: string | null;
  inspectionType?: InspectionType;
}

/** "Every 6 weeks", "Every 12 months", "Every day". */
export function describeInterval(t: { intervalNumber: number, intervalUnit: IntervalUnit }): string {
  return t.intervalNumber === 1 ? 'Every ' + t.intervalUnit : `Every ${t.intervalNumber} ${t.intervalUnit}s`;
}

/** YYYY-MM-DD → DD/MM/YYYY (no Date objects, so no timezone shift). */
export function ukDate(iso: string | null | undefined): string {
  if (!iso) {
    return '';
  }
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  return `${d}/${m}/${y}`;
}

/** Today as YYYY-MM-DD in the browser's local time. */
export function todayIso(): string {
  const now = new Date();
  const p = (n: number) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${p(now.getMonth() + 1)}-${p(now.getDate())}`;
}
